import { render, staticRenderFns } from "./FormPFCP.vue?vue&type=template&id=b1279f80&scoped=true"
import script from "./FormPFCP.vue?vue&type=script&lang=js"
export * from "./FormPFCP.vue?vue&type=script&lang=js"
import style0 from "./FormPFCP.vue?vue&type=style&index=0&id=b1279f80&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1279f80",
  null
  
)

export default component.exports